<template lang="pug">
b-card
  validation-observer(ref="form", tag="form")
    b-form
      b-row
        // Physical Location
        b-col(md="6")
          b-form-group(
            :label="$t('label.Physical Location')",
            :label-for="$t('label.physical location')",
            description=""
          )
            validation-provider(:name="$t('label.Physical Location')", rules="required", v-slot="{ errors }")
              b-form-input(
                id="physical_location",
                v-model="data.name",
                trim,
                :placeholder="$t('placeholder.name')"
              )
              small(class="text-danger") {{ errors[0] }}

        // Physical Location Leads
        b-col(md="6")
          b-form-group(
            :label="$t('label.locationLeads')",
            :label-for="$t('label.locationLeads')",
            description=""
          )
            v-select(
              v-model="data.locationLeads",
              :reduce="(locationLeads) => locationLeads.value",
              label="title",
              :multiple="true"
              :options="leads",
              :placeholder="$t('placeholder.responsible')"
            )

      // Button
      b-row
        b-col(
          cols="12"
          class="text-right"
        )
          b-button(
            variant="primary",
            :disabled="isSubmitting",
            @click="validateAndSubmit"
          )
            | {{ $t('message.submit') }}
</template>

<script>
// eslint-disable-next-line import/extensions
import { ref, toRefs, onMounted } from '@vue/composition-api/dist/vue-composition-api'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import { required } from "@validations";
import useNotifications from '@/composables/useNotifications'
import i18n from '@/libs/i18n'
import useCommon from '@/views/organization/useCommon'
import vSelect from 'vue-select'

export default {
  name: 'Form',

  components: {
    ValidationObserver,
    ValidationProvider,
    vSelect
  },

  props: ['data', 'isSubmitting'],

  setup(props, { emit }) {
    const { showErrorMessage } = useNotifications()
    const form = ref(null)
    const { getdepartmentLeadsForDropDown, leads } = useCommon()

    const validatePhysicalLocation = () => new Promise((resolve, reject) => {
      form.value.validate().then(success => {
        if (success) resolve(true)
        else reject()
      })
    })

    const validateAndSubmit = () => {
      validatePhysicalLocation()
      .then(() => emit('submit', toRefs(props.data)))
      .catch(() => showErrorMessage(i18n.t('message.requiredFieldsIncomplete')))
    }

    onMounted(async () => {
      getdepartmentLeadsForDropDown()
    })

    return {
      required,
      form,
      validateAndSubmit,
      leads
    }
  },
}
</script>

<style scoped>

</style>
